import {ChangeDetectionStrategy, Component, computed, inject, ViewEncapsulation} from '@angular/core';
import {SidebarNavService} from '../sidebar-nav/sidebar-nav.service';
import {WindowSizeService} from '../../services/window-size.service';
import {AppConfigService} from '../../services/app-config.service';
import {LayoutService} from '../../modules/layout/layout.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  private router = inject(Router);
  private windowSizeService = inject(WindowSizeService);
  private layoutService = inject(LayoutService);
  public shouldUseNarrowMainContainer = this.layoutService.shouldUseNarrowMainContainer;
  private sidebarNavService = inject(SidebarNavService);
  private appConfigService = inject(AppConfigService);
  public s3AssetUrl = `${this.appConfigService.appConfig.amazonS3Url}assets/`;
  private size = this.windowSizeService.windowSize;
  public isDesktopImageVisible = computed<boolean>(
    () => this.size() && this.size()[0] >= 1440 && this.shouldUseNarrowMainContainer() === false,
  );

  public getContainerClasses() {
    const narrow = this.shouldUseNarrowMainContainer();
    return {
      'max-w-[1208px]': narrow,
      'max-w-screen-2xl': !narrow,
      'pl-3': !narrow,
      'px-2': narrow,
    };
  }

  public menuToggle() {
    this.sidebarNavService.toggleSidebarNav();
  }
}
